export default {"src":"/_next/static/media/fire-slateus.aefa304c.svg","height":100,"width":100};